import React, { FC } from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import { DateFormat } from '../../helpers/dateFormat';
import { useTranslation } from 'react-i18next';
import { Date } from '../Date/Date';
import { IProductDetails } from '../../models/ProductDetails';
import { IInstaller } from '../../models/Installer';

interface IProps {
  product: Omit<IProductDetails, 'plans'>;
  installers: IInstaller[];
}

export const OverviewReleases: FC<IProps> = ({ product, installers }) => {
  const { t } = useTranslation();

  return (
    <Table>
      <TableHead>
        <TableRow>
          <TableCell>{t('userOverview.productHeader')}</TableCell>
          <TableCell>{t('userOverview.releaseDateHeader')}</TableCell>
        </TableRow>
      </TableHead>
      <TableBody>
        {installers.map((installer) => {
          return (
            <TableRow key={installer.version}>
              <TableCell>
                {product.name} &ndash; {installer.version}
              </TableCell>
              <TableCell>
                <Date date={installer.released} format={DateFormat.DateMedium} />
              </TableCell>
            </TableRow>
          );
        })}
      </TableBody>
    </Table>
  );
};
